import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  coowners: [],
  coowner: false,
  loading: false,
  formLoading: false,
  exportLoading: false,
  error: false,
  success: false,
  downloadCoownersLink: '',
  imageURL: '',
  section: [],
  allFields: {},
  getfields: {},
  coownerSectionPermission: {},
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Coowners/index.js